export default __webpack_public_path__ + "static/media/plant-and-bee.df490404.svg";